import { Navigate, RouteObject } from 'react-router-dom';

import { pagePathSegments } from '~constants';
import { KeyDetailsPage, KeysPage } from '~features/keys';

import PreserveSearchNavigate from './components/preserveSearchNavigate';

const KeysRoutes = (): RouteObject[] => {
	return [
		{
			path: pagePathSegments.Keys,
			children: [
				{
					index: true,
					element: <Navigate to={pagePathSegments.Assigned} replace />,
				},
				{
					path: pagePathSegments.Assigned,
					element: <KeysPage keysListType='assigned' />,
				},
				{
					path: pagePathSegments.Unassigned,
					element: <KeysPage keysListType='unassigned' />,
				},
				{
					path: ':id',
					children: [
						{
							index: true,
							element: <PreserveSearchNavigate to={pagePathSegments.General} />,
						},
						{
							path: pagePathSegments.General,
							element: <KeyDetailsPage tab='general' />,
						},
						{
							path: pagePathSegments.OfflineAccess,
							element: <KeyDetailsPage tab='offline-access' />,
						},
					],
				},
			],
		},
	];
};

export default KeysRoutes;
